import { Action, AssistantType, ConstraintFilterInterface, NamespaceType } from '@vendasta/ai-assistants';

export function createConstraintFilters(
  partnerId?: string | null,
  accountGroupId?: string | null,
  assistantType?: AssistantType,
): ConstraintFilterInterface[] {
  const constraintFilters: ConstraintFilterInterface[] = [];

  if (accountGroupId) {
    // Filter for goals viewable and assignable to account group assistants
    constraintFilters.push(
      {
        action: Action.ACTION_VIEW,
      },
      {
        action: Action.ACTION_ASSIGN,
        scope: {
          assistantNamespaceType: NamespaceType.NAMESPACE_TYPE_ACCOUNT_GROUP,
        },
      },
    );
  } else if (partnerId) {
    // Filter for goals viewable and assignable to partner assistants
    constraintFilters.push(
      {
        action: Action.ACTION_VIEW,
      },
      {
        action: Action.ACTION_ASSIGN,
        scope: {
          assistantNamespaceType: NamespaceType.NAMESPACE_TYPE_PARTNER,
        },
      },
    );
  }

  // Add constraint filter for goals assignable to the specific assistant type
  if (assistantType) {
    constraintFilters.push({
      action: Action.ACTION_ASSIGN,
      scope: {
        assistantType: assistantType,
      },
    });
  }

  return constraintFilters;
}
